import {INotification} from "src/providers/NotificationProvider";
import {NotificationItem} from "../NotificationItems";
import NotificationAvoidAreaItem from "../NotificationItems/NotificationAvoidAreaItem";
import NotificationInterestAreaItem from "../NotificationItems/NotificationInterestAreaItem";

interface Props {
    data: Array<INotification>;
    title: string;
}

const NOTIFICATION_COMPONENT_MAP = {
    TRIP_ACCEPT: NotificationItem.NotificationAcceptedItem,
    TRIP_REFUSE: NotificationItem.NotificationRefusedItem,
    TRIP_PROPOSED: NotificationItem.NotificationProposalItem,
    AVOID_AREA: NotificationAvoidAreaItem,
    INTEREST: NotificationInterestAreaItem,
    TRIP_DEVIATION: NotificationItem.NotificationRouteDeviationItem,
    SUGGESTED_ROUTE_FASTEST: NotificationItem.NotificationRouteSuggestionItem,
    SUGGESTED_ROUTE_ECONOMIC: NotificationItem.NotificationRouteSuggestionItem,
    SUGGESTED_ROUTE_LESS_CONSUMPTION: NotificationItem.NotificationRouteSuggestionItem,
    SUGGESTED_ROUTE_NOT_MAPPED: NotificationItem.NotificationRouteSuggestionItem,
    TRIP_STATUS_UPDATE_REQUIRED: NotificationItem.NotificationFleetManagerHecTrip,
} as const;

const NotificationList = ({ data, title }: Props) => {
    return (
        <div className="panel panel-default margin-bottom-0">
            <div className="panel-heading padding-x-25 padding-y-15" style={{ borderBottomWidth: 2 }}>
                <div className="display-flex column-gap-10 justify-content-between divider">
                    <span className="text-bold text-size-16 line-height-24 ">{title}</span>
                </div>
            </div>

            {data && data.length > 0 ? (
                <div className="panel-body padding-0">
                    <ul className="list-group divider-y-2">
                        {data
                            .filter(notification =>
                                notification.type &&
                                NOTIFICATION_COMPONENT_MAP[notification.type as keyof typeof NOTIFICATION_COMPONENT_MAP]
                            )
                            .map((notification, index) => {
                                const NotificationComponent = NOTIFICATION_COMPONENT_MAP[notification.type as keyof typeof NOTIFICATION_COMPONENT_MAP];

                                return (
                                    <li className="list-group-item padding-0 rounded-bottom-left rounded-bottom-right" key={index}>
                                        <NotificationComponent {...notification} />
                                    </li>
                                );
                            })}
                    </ul>
                </div>
            ) : (
                <div className="display-flex justify-content-center max-width-100pct">
                    <div className="margin-0 width-100pct max-width-600 panel-default panel padding-15 border-none">
                        <div className="display-flex flex-column align-items-center text-center padding-25">
                            <div className="text-size-h2 margin-bottom-20">
                                <span className="rioglyph text-color-light rioglyph rioglyph-notification text-size-300pct"></span>
                            </div>
                            <div className="text-size-h3 text-size-h2-sm line-height-125rel text-color-dark text-medium width-500 max-width-100pct">
                                Não há novas notificações
                            </div>
                            <div className="text-color-dark margin-top-15 width-500 max-width-100pct">
                                Se algo novo surgir, avisaremos você aqui.
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationList;
